import { render, staticRenderFns } from "./LostPassword.vue?vue&type=template&id=79faf608&"
import script from "./LostPassword.vue?vue&type=script&lang=js&"
export * from "./LostPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports